import { InjectionToken } from '@angular/core';
import { TypographySize } from '@bcfds-design-system/components/typography/typography.types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const CMS_LP_HERO_TITLE_SIZE: InjectionToken<TypographySize> = new InjectionToken<TypographySize>(
  'cmsLpHeroTitleSize',
  {
    factory: () => 24
  }
);
